<template>
  <div class="inside">

    <div class="title_h1 yo-color-secondary">{{evento.tipologia}}</div>
    
    <div class="inside-in evento">


      <div class="row">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l10"><h2>{{evento.titolo}}</h2></div>
      </div>


        
      <interventoOspiti :programma="evento.id" ruolo="moderatore"/>

      <div class="row">
        <div class="col s12 m2 l1">&#160;</div>
        <div class="col s12 m10 l10">{{ evento.giorno  | datetime('LL') }} from {{ (evento.giorno+' '+evento.inizio)  | datetime('HH:mm') }} to  {{ evento.giorno+' '+evento.fine  | datetime('HH:mm') }} in {{evento.sala}}</div>
      </div>

        
        

    <h4 v-if="finterventi(evento.id).length>0" style="margin:12px 0;">Schedule</h4>
    
       <div class="evento-child" v-for="intervento in finterventi(evento.id)">
       <intervento-dettaglio :evento="intervento"></intervento-dettaglio>
       </div>


       <div class="yo-align-center">
       <el-button type="primary" v-on:click="$router.go(-1)" style="background-color: #F2A019;border-color: #353535;">Indietro</el-button>
       </div>

    </div>
    
  </div>
</template>

<script>
import interventoOspiti from './Intervento-ospiti.vue'
import interventoDettaglio from './Intervento-dettaglio.vue'

var moment = require('moment');
moment.locale('it');
export default {
  name: 'programma-dettaglio',
  components: {
    interventoDettaglio
    ,interventoOspiti
  },
  created () {
    console.log("Arrivo al Programma-evento.vue con sezione  "+this.$route.params.evento)
  },
  computed: {
      evento: function () {
          console.log('àààààààààààààààààààààààààààààààààààààààààààààààààààààààà')
          for (let item of this.$teras._programma){
            console.log(item.id+' == '+ this.$route.params.evento)
            if(item.id == this.$route.params.evento)
                return item
          }
      }
      
  },
  methods:{
    finterventi(id){
        var isFilter = []
        for (let item of this.$teras._programma){
            console.log(item)
            if(item.parent == id)
                isFilter.push(item)
        }
        return isFilter
    }
  },
  filters: {
    datetime (value,formato) {
        return moment(value).format(formato)
    },
    citta (value) {
        if(value!=''){
            value = ' ('+value+')'
        }
        return value
    }
  }
}
</script>


<style>
.evento{
    margin-bottom:40px;
}span.ospite:not(:last-child):after {
    content:', ';
}

</style>
